var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1EFEF0A4-B6EF-44A7-94F5-9175114FD00C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96C4F9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E76B5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Application--Submitted--Awaiting-Signatures",
    transform: "translate(-704.000000, -323.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(337.618698, 213.221393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check",
    transform: "translate(367.253814, 110.624205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.225,0 C3.2409752,0 0,3.2409752 0,7.225 C0,11.2090248 3.2409752,14.45 7.225,14.45 C11.2090248,14.45 14.45,11.2090248 14.45,7.225 C14.45,3.2409752 11.2090248,0 7.225,0 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4611933,4.41599885 C11.3219855,4.84789536 11.3134191,5.07279245 11.3134191,5.26822457 C11.3134191,5.48609129 11.2302535,5.7040324 11.0636639,5.87070008 L11.0636639,5.87070008 L7.00209361,9.93215589 L4.00571532,7.84418453 C3.82760124,7.67563403 3.7386551,7.45028958 3.7386551,7.225 C3.7386551,7.00707585 3.82188045,6.78910035 3.98844911,6.62260973 C4.15502727,6.45595353 4.37297179,6.37273293 4.59088082,6.37273293 C4.80875992,6.37273293 5.02671859,6.45593308 5.19335384,6.62256833 L5.19335384,6.62256833 L6.54765904,7.97687353 L9.85876161,4.66587565 C10.0253398,4.49921945 10.2432843,4.41599885 10.4611933,4.41599885 Z",
    id: "Path",
    stroke: "#FAFAFA",
    strokeWidth: 0.5,
    fill: "#FAFAFA"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlue);
export default __webpack_public_path__ + "static/media/checkBlue.2a30f8e57367215d8a632a4306655d7a.svg";
export { ForwardRef as ReactComponent };